import { render, staticRenderFns } from "./AilmentSelectInput.vue?vue&type=template&id=2ff7d1a8"
import script from "./AilmentSelectInput.vue?vue&type=script&lang=ts"
export * from "./AilmentSelectInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports